// src/rtkQuery/features/services/cart/cartApi.slice.ts

import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { buildQuery } from '@/rtkQuery/lib';
import type { AddToCartRequest, AddToCartResponse } from '../../models/cart.model';
import { CART_ENDPOINTS } from '@/rtkQuery/config/cartApi.config';

export const cartApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        addToCart: builder.mutation<AddToCartResponse, AddToCartRequest>({
            query: (body) => buildQuery<AddToCartRequest>(CART_ENDPOINTS.ADD_TO_CART, 'POST')(body),
            transformResponse: (response: any, meta) => {
                if (response?.Result === 'Failure') {
                    (meta as any).status = 'error';
                    (meta as any).error = response?.Message ?? 'Unknown error occurred while adding to cart';
                    throw {
                        status: 400,
                        message: response?.Message ?? 'Something went wrong.',
                        errors: response?.Errors ?? [],
                    };
                }

                (meta as any).status = 'success';
                (meta as any).error = null;
                return response;
            },
            transformErrorResponse: (response: any, meta) => {
                const message = response?.data?.Message || 'Failed to add product to cart';
                (meta as any).status = 'error';
                (meta as any).error = message;

                return {
                    status: response.status || 400,
                    message,
                    errors: response?.data?.Errors || [],
                };
            },
            invalidatesTags: ['Cart', 'RecentOrders'],
        }),

    }),
    overrideExisting: false,
});

export const { useAddToCartMutation } = cartApi;
